import { CarFront, ChevronRight, Wrench } from 'lucide-react'
import { observer } from 'mobx-react-lite'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { NavLink, useSearchParams, useLocation, useNavigate } from 'react-router-dom'
import { Context } from '../../..'
import { CREATE_AN_AD, REGISTRATION_ROUTE, SHOP_ROUTE } from '../../../utils/consts'
import { useScreenSize } from '../../../utils/hooks/hooks'
import BuyAPart from '../../mainPage/buyAPart/BuyAPart'
import PlaceAnAd from '../../mainPage/placeAnAd/PlaceAnAd'
import BeforeAfterSlider from '../../ui/BeforeAfterSlider'
import AccessAlert from '../../ui/modal/AccessAlert/AccessAlert'
import styles from './Main.module.scss'

const MainPage = observer(() => {
	const { user } = useContext(Context)
	const [searchParams, setSearchParams] = useSearchParams()
	const [accessAlertShow, setAccessAlertShow] = useState(false)
	const [alertTitle, setAlertTitle] = useState('')
	const confirm = searchParams.get('confirm')
	const sliderRef = useRef(null)

	useEffect(() => {
		if (confirm) {
			setAccessAlertShow(true)
			setAlertTitle('Вы успешно активировали аккаунт.')
			setSearchParams({})
		}
	}, [confirm])

	const isMobileScreen = useScreenSize(728)
	
	return (
		<div className='pb-10'>
			<div className={`${styles.wrap} flex justify-between`}>
				<div className={styles.wrap__left}>
					<h1>
						С вероятностью
						<br />
						96% продаем
						<br />
						деталь
					</h1>
					<div className={`${styles.wrap__left__inline__wrap}`}>
						{!user.isAuth ? (
							<NavLink to={REGISTRATION_ROUTE}>
								<div className={`${styles.wrap__left__inline}`}>
									<button
										type='button'
										className={`button button-black ${styles.button}`}>
										Зарегистрироваться
									</button>
									<span className={styles.circle}>
										<span
											className={`flex justify-center items-center ${styles.circle__in}`}>
											<ChevronRight className={styles.arrow} />
										</span>
									</span>
								</div>
							</NavLink>
						) : (
							''
						)}
					</div>
				</div>
				<div className={`${styles.wrap__right} flex justify-center`}>
					<div
						ref={sliderRef}
						className='w-full 2sm:w-[485px] h-[250px] 2sm:h-[300px] mx-auto'>
						<BeforeAfterSlider
							beforeImage='/images/old_car.jpg'
							afterImage='/images/new_car.jpg'
							containerRef={sliderRef}
						/>
					</div>
				</div>
			</div>

			<div className='xl:flex-row flex-col gap-y-10 flex justify-between mt-8 lg:mt-12 items-center xl:items-end'>
				<div className='lg:flex-row flex gap-6 flex-col w-full justify-center lg:justify-start xl:max-w-fit'>
					<PlaceAnAd
						type=''
						icon={<CarFront />}
						headerTitle={<div className={styles.underTitle}>Продавать запчасти легко</div>}
						underTitle={
							<h5 className={`
								font-normal tracking-[-0.8px]
								${isMobileScreen ? 'text-[32px] leading-[31px]' : 'text-[40px] leading-[44px]'}
							`}>
								Разместить
								<br />
								объявление
							</h5>
						}
						link={CREATE_AN_AD}
						status={!user.isAuth ? 'Unauthorized' : 'Authorized'}
					/>

					<BuyAPart
						icon={<Wrench />}
						headerTitle='Перейти'
						underTitle={
						<h5 className={`
							font-normal tracking-[-0.8px]
							${isMobileScreen ? 'text-[32px] leading-[31px]' : 'text-[40px] leading-[44px]'}
						`}>
							Купить деталь
						</h5>
						}
						pieces='Выбери нужную деталь'
						link={SHOP_ROUTE}
					/>
				</div>

				<div className={`${styles.under__photo}`}>
					<p className='text-lg text-center r-md:text-left'>
						<strong>GearStore</strong> - Универсальная платформа для продажи
						и&nbsp;покупки запчастей для автомобилей. Частные лица и&nbsp;компании могут
						бесплатно размещать объявления, продавать новые и&nbsp;б/у автозапчасти,
						а&nbsp;покупатели — легко находить нужные детали по марке, модели или
						категории. Удобный поиск, прозрачные сделки и&nbsp;простая публикация
						объявлений делают GearStore надёжным помощником для автолюбителей
						и&nbsp;профессионалов.
					</p>
				</div>
			</div>
			<AccessAlert
				open={accessAlertShow}
				setOpen={setAccessAlertShow}
				alertTitle={alertTitle}
			/>
		</div>
	)
})

export default MainPage
